var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36364 0.892857C1.11259 0.892857 0.909091 1.09273 0.909091 1.33929V23.6607C0.909091 23.9073 1.11259 24.1071 1.36364 24.1071H18.6364C18.8874 24.1071 19.0909 23.9073 19.0909 23.6607V6.25H15C14.2469 6.25 13.6364 5.6504 13.6364 4.91071V0.892857H1.36364ZM14.5455 1.5242L18.4481 5.35714H15C14.749 5.35714 14.5455 5.15728 14.5455 4.91071V1.5242ZM0 1.33929C0 0.599616 0.6105 0 1.36364 0H14.0909C14.2115 0 14.3271 0.0470357 14.4123 0.130755L19.8669 5.4879C19.9521 5.57161 20 5.68518 20 5.80357V23.6607C20 24.4004 19.3895 25 18.6364 25H1.36364C0.6105 25 0 24.4004 0 23.6607V1.33929Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.8335,
    y: 10.5,
    width: 12.3333,
    height: 7.33333,
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09907 16.6679C9.27587 16.6705 9.44669 16.5995 9.57141 16.4705L13.1569 12.8008C13.3978 12.535 13.3909 12.1218 13.1415 11.8648C12.8913 11.6086 12.489 11.6016 12.2302 11.849L9.09904 15.0466L7.78711 13.6991C7.53002 13.4385 7.11748 13.4385 6.86039 13.6991C6.73654 13.8246 6.6665 13.9965 6.6665 14.1755C6.6665 14.3544 6.73654 14.5255 6.86039 14.6509L8.63611 16.4792H8.63525C8.76081 16.6011 8.92653 16.6688 9.09907 16.6679Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCheck);
export default __webpack_public_path__ + "static/media/documentCheck.b357e4ab391e3a5a8d3e378d780ca7d8.svg";
export { ForwardRef as ReactComponent };